export const newDashboardMap = {
  Tech: {
    user_sf: ["GIB/Technology SF/Junior Banker View", "gibtech"],
    user_ny: ["GIB/Technology NY/Junior Banker View", "gibtech"],
    staffer_sf: ["GIB/Technology SF/Staffer View", "staffing"],
    staffer_ny: ["GIB/Technology NY/Staffer View", "staffing"],
    grouphead: ["Technology Group Head", "TechWidgetGroupHead"],
    admin_sf: ["GIB/Technology SF/Business Manager View", "Technology Admin"],
    admin_ny: ["GIB/Technology NY/Business Manager View", "Technology Admin"],
  },
  SD: {
    user: ["Sponsorships And Donations Analyst", "sponsors-analyst"],
    staffer: ["Sponsorships And Donations Staffer", "sponsors-staffer"],
    manager: ["Sponsorships And Donations Manager", "sponsors-manager"],
  },
  FIG: {
    user: ["FIG", "fig"],
    staffer: ["FIG Manager", "fig-manager"], //
  },
  PUI: {
    user: ["GIB/PU&I/Junior Banker View","power_analyst"],
    staffer: ["GIB/PU&I/Staffer View", "power",],
  },
  LF: {
    user: ["GIB/Leveraged Finance/Junior Banker View", "levfin"],
    staffer: ["GIB/Leveraged Finance/Staffer View", "levfin-staffer"], //
    grouphead: ["GIB/Leveraged Finance/Business Manager View", "LevFinWidgetGroupHead"],
  },
  HC: {
    user: ["Healthcare/Junior Banker View", "healthcare_analyst"],
    staffer: ["Healthcare", "healthcare"],
  },
  CR: {
    user: ["Consumer And Retail", "consumerRegular"],
    staffer: ["Consumer And Retail Admin", "consumer"], //
  },
  GPC: {
    user: ["GPC", "gpc"],
  },
  MA: {
    user: ["M&A/Junior Banker View", "merger"],
    staffer: ["Mergers Manager", "mergers-manager"], //
  },
  CME: {
    user: ["CME", "CMEWidgetUser"],
    staffer: ["CME Staffer", "CMEWidgetStaffer"],
    grouphead: ["CME Group Head", "CMEWidgetGroupHead"], //
  },
  RE: {
    user: ["Real Estate", "REWidgetUser"],
    staffer: ["Real Estate Staffer", "REWidgetStaffer"],
  },
  TechCME: {
    staffer: ["CMETechWidgetStaffer", "CMETechWidgetStaffer"],
  },
  L2L: {
    user: ["Sales Team", "Sales Team"],
  },
  Energy: {
    user: ["GIB/Energy/Junior Banker View"],
    staffer: ["GIB/Energy/Staffer View"],
  },
  EnergySI: {
    user: ["GIB/Energy/SI Junior Banker View"],
    staffer: ["GIB/Energy/SI Staffer View"],
  },
  All: {
    user: ["All", "allRbc"],
  },
};

export const compareCurrentSubdepartment = (list, currSubDepartment) => {
  return list?.some(
    (sd) =>
      sd?.trim()?.toLowerCase() === currSubDepartment?.trim()?.toLowerCase()
  );
};

export const shouldFetchData = (subDepartments, mapKeys) => {
  if (!subDepartments || !mapKeys) return false;
  
  return subDepartments.some(subDepartment => 
    mapKeys.some(key => {
      const departmentConfig = newDashboardMap[key];
      if (!departmentConfig) return false;
      
      // Dynamically collect all array values from any property
      const departmentUsers = Object.values(departmentConfig).filter(Array.isArray).flat();
      const allUsers = [...departmentUsers, ...(newDashboardMap.All?.user || [])];
      
      return compareCurrentSubdepartment(allUsers, subDepartment);
    })
  );
};

export const findNewSubdepartment = (str) => {
  for (const category in newDashboardMap) {
    for (const role in newDashboardMap[category]) {
      if (
        newDashboardMap[category][role]?.some(
          (sd) => sd?.trim()?.toLowerCase() === str?.trim()?.toLowerCase()
        )
      ) {
        return [newDashboardMap[category][role][0]];
      }
    }
  }

  return [""];
};
